import { render, staticRenderFns } from "./Cbutton.vue?vue&type=template&id=0b2e1830&scoped=true"
import script from "./Cbutton.vue?vue&type=script&lang=js"
export * from "./Cbutton.vue?vue&type=script&lang=js"
import style0 from "./Cbutton.vue?vue&type=style&index=0&id=0b2e1830&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2e1830",
  null
  
)

export default component.exports